module.exports = __webpack_public_path__ + "media/images/home/3cadvertise-3bd3e2b6a6954a2113f5628b96bb040f.png";